import React, { useEffect, useRef } from "react";
import { gsap, SteppedEase } from "gsap/all";
import logoPaths from "./svg_logo";
import * as logoStyles from "./Logo.module.scss";

interface LogoProps {
  center?: boolean;
}

function getRandom(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

const Logo = ({ center }: LogoProps) => {
  const pathRefs = useRef<(SVGPathElement | null)[]>([]);
  const masterTl = useRef<gsap.core.Timeline | null>(null);

  useEffect(() => {
    const paths = pathRefs.current;

    const opener = new gsap.timeline({ id: "opener" });
    paths.forEach(path => {
      opener.set(path, {
        transformOrigin: "center center",
        opacity: 0,
        ease: "power4.in",
        rotation: 365 * getRandom(1, 3),
      });
    });
    opener.to(paths, {
      id: "normalise",
      x: 0, y: 0, opacity: 1, scale: 1,
      duration: 4, rotation: 0, stagger: 0.001,
    });

    masterTl.current = new gsap.timeline({
      repeat: -1, yoyo: true, repeatRefresh: true,
    });
    masterTl.current.play();

    masterTl.current
      .to(paths, { delay: 4, duration: 1, ease: SteppedEase.easeInOut, stagger: 0.5, rotation: 360 })
      .to(paths, { fill: "#ff7601", duration: 2, stagger: { amount: 1, from: "center", grid: "auto" }, ease: SteppedEase.easeInOut }, ">")
      .to(paths, { delay: 2, duration: 4, ease: "power4.easeInOut", rotation: -360 })
      .to(paths, { strokeWidth: 2, duration: 4, stroke: "#1f2528" })
      .to(paths, {
        duration: 3, rotation: 360, delay: 1,
        stroke: "#ff7601", strokeWidth: 1, fill: "#1f2528",
        stagger: 0.4, ease: "slow(0.5, 0.7, false)",
      });

    return () => {
      masterTl.current?.kill();
      opener.kill();
    };
  }, []);

  return (
    <svg
      className={`${logoStyles.logo}${center ? ` ${logoStyles.logoCentered}` : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 197.84798 102.79235"
    >
      {(logoPaths as string[]).map((path, i) => (
        <path ref={el => (pathRefs.current[i] = el)} key={i} d={path} />
      ))}
    </svg>
  );
};

export default Logo;
